// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Status Monitoring — Dark Data Dashboard Theme */
.admin-monitoring {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.admin-monitoring__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--admin-border);
  background: var(--admin-surface);
}

.admin-monitoring__header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-monitoring__title {
  font-size: 14px;
  font-weight: 600;
  color: var(--admin-text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-monitoring__icon {
  width: 16px;
  height: 16px;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

.admin-monitoring__live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--admin-success);
  animation: livePulse 2s ease-in-out infinite;
}

@keyframes livePulse {
  0%, 100% {
    opacity: 1;
    box-shadow: 0 0 0 0 var(--admin-success-bg);
  }
  50% {
    opacity: 0.7;
    box-shadow: 0 0 0 6px transparent;
  }
}

.admin-monitoring__last-check {
  font-size: 11px;
  color: var(--admin-text-muted);
  font-weight: 400;
  margin-left: 4px;
}

.admin-monitoring__actions {
  display: flex;
  gap: 8px;
}

.admin-monitoring__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  color: var(--admin-text-primary);
  transition: all 0.2s;
}

.admin-monitoring__btn:hover {
  background: var(--admin-surface-hover);
  border-color: var(--admin-text-dim);
}

.admin-monitoring__btn-icon {
  width: 14px;
  height: 14px;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

/* Health Grid */
.admin-monitoring__health-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
  padding: 20px;
  background: var(--admin-bg);
  border-bottom: 1px solid var(--admin-border);
}

.admin-health-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  padding: 16px;
  position: relative;
  overflow: hidden;
  transition: all 0.2s;
}

.admin-health-card:hover {
  border-color: var(--admin-text-dim);
}

.admin-health-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
}

.admin-health-card--ok::after {
  background: var(--admin-success-bg);
}

.admin-health-card--warn::after {
  background: var(--admin-warning-bg);
}

.admin-health-card--error::after {
  background: var(--admin-error-bg);
}

.admin-health-card--off::after {
  background: var(--admin-border);
}

.admin-health-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.admin-health-card__provider {
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-health-card__logo {
  width: 28px;
  height: 28px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 12px;
}

.admin-health-card__name {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-health-card__badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: var(--radius-full);
}

.admin-health-card__badge--ok {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-health-card__badge--warn {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-health-card__badge--error {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

.admin-health-card__badge--off {
  background: var(--admin-surface-hover);
  color: var(--admin-text-muted);
}

.admin-health-card__metrics {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}

.admin-health-metric {
  text-align: center;
}

.admin-health-metric__value {
  font-size: 16px;
  font-weight: 700;
  color: var(--admin-text-primary);
}

.admin-health-metric__value--ok {
  color: var(--admin-success);
}

.admin-health-metric__value--warn {
  color: var(--admin-warning);
}

.admin-health-metric__value--error {
  color: var(--admin-error);
}

.admin-health-metric__label {
  font-size: 10px;
  color: var(--admin-text-muted);
  margin-top: 1px;
}

/* Filter */
.admin-monitoring__filter {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--admin-border);
  background: var(--admin-surface);
  flex-wrap: wrap;
}

.admin-monitoring__filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-monitoring__filter-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  white-space: nowrap;
}

.admin-monitoring__filter-select {
  padding: 6px 10px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 12px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  cursor: pointer;
}

.admin-monitoring__filter-select:focus {
  outline: none;
  border-color: #a78bfa;
}

.admin-monitoring__filter-search {
  padding: 6px 10px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 12px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  min-width: 180px;
}

.admin-monitoring__filter-search:focus {
  outline: none;
  border-color: #a78bfa;
}

.admin-monitoring__error-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: var(--radius-full);
  font-size: 11px;
  font-weight: 600;
  margin-left: auto;
}

.admin-monitoring__error-badge--error {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

.admin-monitoring__error-badge--warn {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-monitoring__error-badge svg {
  stroke: currentColor;
  fill: none;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  vertical-align: -1px;
}

.admin-monitoring__error-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  vertical-align: 0px;
}

.admin-monitoring__error-dot--critical {
  background: #ef4444;
}

/* Table */
.admin-monitoring__table-wrap {
  overflow-x: auto;
}

.admin-monitoring__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.admin-monitoring__table th {
  text-align: left;
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: var(--admin-surface);
  border-bottom: 1px solid var(--admin-border);
  white-space: nowrap;
}

.admin-monitoring__table td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--admin-border-light);
  vertical-align: middle;
  color: var(--admin-text-primary);
}

.admin-monitoring__table tbody tr {
  transition: background 0.15s;
  cursor: pointer;
}

.admin-monitoring__table tbody tr:hover {
  background: var(--admin-surface-hover);
}

.admin-monitoring__table tbody tr:last-child td {
  border-bottom: none;
}

.admin-error-time {
  font-size: 12px;
  color: var(--admin-text-secondary);
  white-space: nowrap;
}

.admin-error-time__date {
  font-size: 10px;
  color: var(--admin-text-muted);
}

.admin-error-provider {
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-error-provider__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.admin-error-model {
  font-family: monospace;
  font-size: 12px;
  background: var(--admin-bg);
  color: var(--admin-text-secondary);
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  white-space: nowrap;
}

.admin-error-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: var(--radius-full);
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.admin-error-type-badge--critical {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

.admin-error-type-badge--warning {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-error-type-badge--timeout {
  background: rgba(96, 165, 250, 0.12);
  color: #60a5fa;
}

.admin-error-type-badge--rate {
  background: rgba(167, 139, 250, 0.12);
  color: #a78bfa;
}

.admin-error-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  vertical-align: 0px;
}

.admin-error-dot--critical {
  background: #ef4444;
}

.admin-error-dot--warning {
  background: #f59e0b;
}

.admin-error-dot--timeout {
  background: #3b82f6;
}

.admin-error-dot--rate {
  background: #8b5cf6;
}

.admin-error-status-code {
  font-family: monospace;
  font-size: 12px;
  font-weight: 600;
}

.admin-error-status-code--4xx {
  color: var(--admin-warning);
}

.admin-error-status-code--5xx {
  color: var(--admin-error);
}

.admin-error-status-code--timeout {
  color: var(--admin-text-secondary);
}

.admin-error-msg {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  color: var(--admin-text-secondary);
}

.admin-error-resolved {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: var(--radius-full);
}

.admin-error-resolved--yes {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-error-resolved--no {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

/* Footer */
.admin-monitoring__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid var(--admin-border);
  background: var(--admin-surface);
}

.admin-monitoring__info {
  font-size: 12px;
  color: var(--admin-text-muted);
}

.admin-monitoring__pagination {
  display: flex;
  align-items: center;
  gap: 4px;
}

.admin-monitoring__page-btn {
  width: 32px;
  height: 32px;
  border: 1px solid var(--admin-border);
  background: var(--admin-bg);
  border-radius: var(--radius-sm);
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-text-secondary);
  transition: all 0.15s;
}

.admin-monitoring__page-btn:hover:not(:disabled) {
  border-color: #a78bfa;
  color: #a78bfa;
}

.admin-monitoring__page-btn--active {
  background: var(--admin-border);
  color: var(--admin-text-primary);
  border-color: var(--admin-border);
}

.admin-monitoring__page-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

/* Modal */
.admin-monitoring__modal-overlay {
  display: flex;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.admin-monitoring__modal {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.admin-monitoring__modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-monitoring__modal-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-monitoring__modal-close {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  background: var(--admin-bg);
  border: none;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-text-secondary);
  transition: all 0.2s;
}

.admin-monitoring__modal-close:hover {
  background: var(--admin-border);
  color: var(--admin-text-primary);
}

.admin-monitoring__modal-body {
  padding: 24px;
  overflow-y: auto;
  max-height: calc(90vh - 140px);
}

.admin-monitoring__modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--admin-border);
  background: var(--admin-surface);
}

.admin-monitoring__modal-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.admin-monitoring__modal-btn--primary {
  background: linear-gradient(135deg, #a78bfa, #7c3aed);
  color: white;
}

.admin-monitoring__modal-btn--primary:hover {
  background: linear-gradient(135deg, #7c3aed, #6d28d9);
  box-shadow: 0 4px 12px rgba(167, 139, 250, 0.3);
}

.admin-monitoring__modal-btn--secondary {
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  color: var(--admin-text-primary);
}

.admin-monitoring__modal-btn--secondary:hover {
  background: var(--admin-surface-hover);
  border-color: var(--admin-text-dim);
}

.admin-monitoring__modal-btn-icon {
  width: 14px;
  height: 14px;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

/* Detail Sections */
.admin-detail-section-title {
  font-size: 13px;
  font-weight: 600;
  margin: 20px 0 8px;
  color: var(--admin-text-primary);
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-detail-section-title:first-child {
  margin-top: 0;
}

.admin-detail-section-title svg {
  stroke: currentColor;
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  vertical-align: -2px;
}

.admin-detail-grid {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 0;
}

.admin-detail-grid dt {
  font-size: 12px;
  font-weight: 600;
  color: var(--admin-text-muted);
  padding: 8px 0;
  border-bottom: 1px solid var(--admin-border);
}

.admin-detail-grid dd {
  font-size: 13px;
  color: var(--admin-text-primary);
  padding: 8px 0;
  border-bottom: 1px solid var(--admin-border);
}

.admin-detail-grid dd:last-child,
.admin-detail-grid dt:last-of-type {
  border-bottom: none;
}

.admin-detail-code {
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  padding: 14px 16px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-family: monospace;
  font-size: 12px;
  line-height: 1.6;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-all;
  margin-top: 8px;
}

.admin-detail-timeline {
  position: relative;
  padding-left: 20px;
}

.admin-detail-timeline::before {
  content: '';
  position: absolute;
  left: 5px;
  top: 4px;
  bottom: 4px;
  width: 2px;
  background: var(--admin-border);
}

.admin-detail-timeline-item {
  position: relative;
  padding: 6px 0;
  font-size: 12px;
}

.admin-detail-timeline-item::before {
  content: '';
  position: absolute;
  left: -19px;
  top: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid var(--admin-border);
  background: var(--admin-surface);
}

.admin-detail-timeline-item--error::before {
  border-color: var(--admin-error);
  background: var(--admin-error-bg);
}

.admin-detail-timeline-item--success::before {
  border-color: var(--admin-success);
  background: var(--admin-success-bg);
}

.admin-detail-timeline-item__time {
  color: var(--admin-text-muted);
  font-size: 11px;
}

.admin-detail-timeline-item__text {
  color: var(--admin-text-secondary);
}

/* ============================================================
 * P3-1 ~ P3-3, P2-4 신규 구조 (탭 / 메트릭 / 이벤트 / 로그 / 장애패턴)
 * ============================================================ */

/* ---- Panel ---- */
.admin-monitoring__panel {
  padding: 0;
}

/* ---- Empty states ---- */
.admin-monitoring__empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 60px 20px;
  color: var(--admin-text-muted);
  font-size: 13px;
}

.admin-monitoring__empty-sub {
  margin-top: 8px;
  font-size: 11px;
  color: var(--admin-text-muted);
}

.admin-monitoring__empty-cell {
  text-align: center;
  padding: 60px 20px !important;
  color: var(--admin-text-muted);
}

.admin-monitoring__empty-illus {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 72px;
  height: 72px;
  margin: 0 auto 12px;
  border-radius: 50%;
  background: var(--admin-surface-hover);
  color: var(--admin-text-muted);
}

.admin-monitoring__empty-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-secondary);
  margin-bottom: 4px;
}

/* ---- Health Card (갱신 - 필드 실사 대응) ---- */
.admin-health-card__info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
}

.admin-health-card__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
}

.admin-health-card__row-label {
  color: var(--admin-text-muted);
  flex-shrink: 0;
}

.admin-health-card__row-value {
  color: var(--admin-text-primary);
  font-weight: 500;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ---- Stat Cards (메트릭 요약) ---- */
.admin-monitoring__stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
  padding: 20px;
  background: var(--admin-bg);
  border-bottom: 1px solid var(--admin-border);
}

.admin-monitoring__stat-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  padding: 14px 16px;
  position: relative;
  overflow: hidden;
  transition: border-color 0.2s;
}

.admin-monitoring__stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 3px;
}

.admin-monitoring__stat-card--primary::before { background: var(--primary-500); }
.admin-monitoring__stat-card--error::before   { background: var(--admin-error); }
.admin-monitoring__stat-card--success::before { background: var(--admin-success); }
.admin-monitoring__stat-card--info::before    { background: var(--admin-info); }
.admin-monitoring__stat-card--muted::before   { background: var(--admin-text-muted); }

.admin-monitoring__stat-card:hover {
  border-color: var(--admin-text-dim);
}

.admin-monitoring__stat-label {
  font-size: 11px;
  color: var(--admin-text-muted);
  font-weight: 500;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.admin-monitoring__stat-value {
  font-size: 22px;
  font-weight: 700;
  color: var(--admin-text-primary);
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.admin-monitoring__stat-unit {
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-muted);
}

/* ---- Chart ---- */
.admin-monitoring__chart-wrap {
  padding: 20px;
  background: var(--admin-surface);
}

.admin-monitoring__chart {
  width: 100%;
  height: auto;
  min-height: 280px;
  display: block;
}

/* ---- Switch ---- */
.admin-monitoring__switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  vertical-align: middle;
}

.admin-monitoring__switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.admin-monitoring__switch-slider {
  position: absolute;
  inset: 0;
  background: var(--admin-border);
  border-radius: 22px;
  transition: background 0.2s;
  cursor: pointer;
}

.admin-monitoring__switch-slider::before {
  content: '';
  position: absolute;
  left: 3px;
  top: 3px;
  width: 16px;
  height: 16px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.admin-monitoring__switch input:checked + .admin-monitoring__switch-slider {
  background: var(--admin-success);
}

.admin-monitoring__switch input:checked + .admin-monitoring__switch-slider::before {
  transform: translateX(18px);
}

.admin-monitoring__switch-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--admin-text-primary);
  cursor: pointer;
  padding: 8px 0;
}

/* ---- Icon Button ---- */
.admin-monitoring__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-sm);
  color: var(--admin-text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}

.admin-monitoring__icon-btn:hover {
  background: var(--admin-surface-hover);
  border-color: var(--primary-500);
  color: var(--primary-600);
}

.admin-monitoring__icon-btn svg {
  width: 14px;
  height: 14px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* ---- Form input/textarea (패턴 편집) ---- */
.admin-monitoring__form-input,
.admin-monitoring__form-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  font-size: 13px;
  font-family: inherit;
  transition: border-color 0.15s, box-shadow 0.15s;
  box-sizing: border-box;
}

.admin-monitoring__form-textarea {
  resize: vertical;
  min-height: 80px;
  line-height: 1.5;
}

.admin-monitoring__form-input:focus,
.admin-monitoring__form-textarea:focus {
  outline: none;
  border-color: var(--primary-500);
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

/* ---- Collapse Button ---- */
.admin-monitoring__collapse-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--admin-text-primary);
  font-size: 13px;
  font-weight: 600;
}

.admin-monitoring__collapse-btn svg {
  width: 12px;
  height: 12px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: transform 0.2s;
}

.admin-monitoring__collapse-btn:hover {
  color: var(--primary-600);
}

/* ---- Larger Modal for Patterns ---- */
.admin-monitoring__modal {
  max-width: 640px;
}

/* ---- Additional badge type (info/debug) ---- */
.admin-error-type-badge--info {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-error-type-badge--debug {
  background: var(--admin-surface-hover);
  color: var(--admin-text-muted);
}

.admin-error-dot--info {
  background: var(--admin-info);
}

.admin-error-dot--debug {
  background: var(--admin-text-muted);
}

/* Spin animation (if not defined elsewhere) */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Health card off state */
.admin-health-card__badge--off {
  background: var(--admin-surface-hover);
  color: var(--admin-text-muted);
}

/* === Redesign: single-page dashboard === */

.admin-monitoring__page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.admin-monitoring__section {
  background: var(--surface, #fff);
  border: 1px solid var(--border-light, #e5e7eb);
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.admin-monitoring__section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.admin-monitoring__section-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary, #111827);
}

.admin-monitoring__section-subtitle {
  font-size: 12px;
  color: var(--text-tertiary, #9ca3af);
  margin-top: 2px;
}

.admin-monitoring__empty-state {
  padding: 28px 16px;
  text-align: center;
  color: var(--text-tertiary, #9ca3af);
  font-size: 13px;
}

.admin-monitoring__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-monitoring__period-select {
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--admin-border, #e5e7eb);
  border-radius: var(--admin-radius-md, 8px);
  background: var(--admin-surface, #fff);
  font-size: 13px;
  color: var(--admin-text-primary, #111827);
  cursor: pointer;
}

.admin-monitoring__auto-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--admin-border, #e5e7eb);
  border-radius: var(--admin-radius-md, 8px);
  background: var(--admin-surface, #fff);
  font-size: 12px;
  color: var(--admin-text-secondary, #4b5563);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.admin-monitoring__auto-toggle--on {
  background: var(--primary-50, #f5f3ff);
  color: var(--primary-700, #6d28d9);
  border-color: var(--primary-200, #ddd6fe);
}
.admin-monitoring__auto-toggle-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--admin-text-muted, #9ca3af);
}
.admin-monitoring__auto-toggle--on .admin-monitoring__auto-toggle-dot {
  background: var(--admin-success, #10b981);
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
}

.admin-monitoring__refresh-meta {
  font-size: 11px;
  color: var(--text-tertiary, #9ca3af);
}
.admin-monitoring__refresh-warn {
  color: var(--admin-warning, #f59e0b);
  font-size: 11px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.admin-monitoring__kpi-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.admin-monitoring__kpi-card {
  background: var(--surface, #fff);
  border: 1px solid var(--border-light, #e5e7eb);
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 82px;
}
.admin-monitoring__kpi-card--warn { border-color: var(--admin-warning, #f59e0b); }
.admin-monitoring__kpi-card--error { border-color: var(--admin-error, #ef4444); }

.admin-monitoring__kpi-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-tertiary, #9ca3af);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.admin-monitoring__kpi-value {
  font-size: 26px;
  font-weight: 700;
  color: var(--text-primary, #111827);
  line-height: 1.1;
}
.admin-monitoring__kpi-sub {
  font-size: 11px;
  color: var(--text-secondary, #4b5563);
}

.admin-monitoring__health-alerts-row {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 16px;
}

.admin-monitoring__metrics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.admin-monitoring__metric-cell {
  background: var(--surface, #fff);
  border: 1px solid var(--border-light, #e5e7eb);
  border-radius: 10px;
  padding: 12px 14px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
}
.admin-monitoring__metric-cell-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 8px;
}
.admin-monitoring__metric-cell-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary, #111827);
}
.admin-monitoring__metric-cell-latest {
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-600, #7c3aed);
}
.admin-monitoring__metric-cell-chart {
  flex: 1 1;
  min-height: 140px;
}

.admin-monitoring__subtabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--border-light, #e5e7eb);
  margin-bottom: 12px;
}
.admin-monitoring__subtab {
  background: transparent;
  border: none;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary, #4b5563);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}
.admin-monitoring__subtab:hover { color: var(--text-primary, #111827); }
.admin-monitoring__subtab--active {
  color: var(--primary-600, #7c3aed);
  border-bottom-color: var(--primary-600, #7c3aed);
}

@media (max-width: 1200px) {
  .admin-monitoring__kpi-strip { grid-template-columns: repeat(2, 1fr); }
  .admin-monitoring__health-alerts-row { grid-template-columns: 1fr; }
}

.admin-monitoring__alerts-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
}
.admin-monitoring__alert-row {
  display: grid;
  grid-template-columns: 10px 1fr auto;
  gap: 8px;
  align-items: start;
  padding: 8px;
  border: 1px solid var(--border-light, #e5e7eb);
  border-radius: 8px;
}
.admin-monitoring__alert-dot { width: 8px; height: 8px; border-radius: 50%; margin-top: 6px; }
.admin-monitoring__alert-title { font-size: 13px; color: var(--text-primary, #111827); }
.admin-monitoring__alert-desc { font-size: 11px; color: var(--text-tertiary, #9ca3af); margin-top: 2px; }
.admin-monitoring__alert-time { font-size: 11px; color: var(--text-tertiary, #9ca3af); white-space: nowrap; }
`, "",{"version":3,"sources":["webpack://./src/css/AdminStatusMonitoring.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,YAAY;IACZ,iCAAiC;EACnC;AACF;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;EAClC,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,MAAM;AACR;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,4CAA4C;AAC9C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;iEAEiE;;AAEjE,oBAAoB;AACpB;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;AACZ;;AAEA,gDAAgD,8BAA8B,EAAE;AAChF,gDAAgD,8BAA8B,EAAE;AAChF,gDAAgD,gCAAgC,EAAE;AAClF,gDAAgD,6BAA6B,EAAE;AAC/E,gDAAgD,mCAAmC,EAAE;;AAErF;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;;EAEE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,8CAA8C;AAC9C;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,0BAA0B;AAC1B;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA,4CAA4C;;AAE5C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,0CAA0C;EAC1C,sCAAsC;EACtC,eAAe;EACf,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,0CAA0C;EAC1C,sCAAsC;EACtC,eAAe;EACf,2CAA2C;EAC3C,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA,oCAAoC,2CAA2C,EAAE;AACjF,qCAAqC,yCAAyC,EAAE;;AAEhF;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qDAAqD;EACrD,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;AACA,kCAAkC,mCAAmC,EAAE;AACvE;EACE,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;EACE,+BAA+B,qCAAqC,EAAE;EACtE,uCAAuC,0BAA0B,EAAE;AACrE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;AACpB;AACA,+BAA+B,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC7F,iCAAiC,eAAe,EAAE,mCAAmC,EAAE;AACvF,gCAAgC,eAAe,EAAE,oCAAoC,EAAE,eAAe,EAAE;AACxG,gCAAgC,eAAe,EAAE,oCAAoC,EAAE,mBAAmB,EAAE","sourcesContent":["/* Admin Status Monitoring — Dark Data Dashboard Theme */\n.admin-monitoring {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.admin-monitoring__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n}\n\n.admin-monitoring__header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.admin-monitoring__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-monitoring__icon {\n  width: 16px;\n  height: 16px;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n}\n\n.admin-monitoring__live-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--admin-success);\n  animation: livePulse 2s ease-in-out infinite;\n}\n\n@keyframes livePulse {\n  0%, 100% {\n    opacity: 1;\n    box-shadow: 0 0 0 0 var(--admin-success-bg);\n  }\n  50% {\n    opacity: 0.7;\n    box-shadow: 0 0 0 6px transparent;\n  }\n}\n\n.admin-monitoring__last-check {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  font-weight: 400;\n  margin-left: 4px;\n}\n\n.admin-monitoring__actions {\n  display: flex;\n  gap: 8px;\n}\n\n.admin-monitoring__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  color: var(--admin-text-primary);\n  transition: all 0.2s;\n}\n\n.admin-monitoring__btn:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-text-dim);\n}\n\n.admin-monitoring__btn-icon {\n  width: 14px;\n  height: 14px;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n}\n\n/* Health Grid */\n.admin-monitoring__health-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 12px;\n  padding: 20px;\n  background: var(--admin-bg);\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-health-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  padding: 16px;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.2s;\n}\n\n.admin-health-card:hover {\n  border-color: var(--admin-text-dim);\n}\n\n.admin-health-card::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n}\n\n.admin-health-card--ok::after {\n  background: var(--admin-success-bg);\n}\n\n.admin-health-card--warn::after {\n  background: var(--admin-warning-bg);\n}\n\n.admin-health-card--error::after {\n  background: var(--admin-error-bg);\n}\n\n.admin-health-card--off::after {\n  background: var(--admin-border);\n}\n\n.admin-health-card__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.admin-health-card__provider {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-health-card__logo {\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.admin-health-card__name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-health-card__badge {\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n}\n\n.admin-health-card__badge--ok {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-health-card__badge--warn {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-health-card__badge--error {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n.admin-health-card__badge--off {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-muted);\n}\n\n.admin-health-card__metrics {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 8px;\n}\n\n.admin-health-metric {\n  text-align: center;\n}\n\n.admin-health-metric__value {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--admin-text-primary);\n}\n\n.admin-health-metric__value--ok {\n  color: var(--admin-success);\n}\n\n.admin-health-metric__value--warn {\n  color: var(--admin-warning);\n}\n\n.admin-health-metric__value--error {\n  color: var(--admin-error);\n}\n\n.admin-health-metric__label {\n  font-size: 10px;\n  color: var(--admin-text-muted);\n  margin-top: 1px;\n}\n\n/* Filter */\n.admin-monitoring__filter {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n  flex-wrap: wrap;\n}\n\n.admin-monitoring__filter-group {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-monitoring__filter-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  white-space: nowrap;\n}\n\n.admin-monitoring__filter-select {\n  padding: 6px 10px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  cursor: pointer;\n}\n\n.admin-monitoring__filter-select:focus {\n  outline: none;\n  border-color: #a78bfa;\n}\n\n.admin-monitoring__filter-search {\n  padding: 6px 10px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  min-width: 180px;\n}\n\n.admin-monitoring__filter-search:focus {\n  outline: none;\n  border-color: #a78bfa;\n}\n\n.admin-monitoring__error-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: var(--radius-full);\n  font-size: 11px;\n  font-weight: 600;\n  margin-left: auto;\n}\n\n.admin-monitoring__error-badge--error {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n.admin-monitoring__error-badge--warn {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-monitoring__error-badge svg {\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 2.5;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  vertical-align: -1px;\n}\n\n.admin-monitoring__error-dot {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  vertical-align: 0px;\n}\n\n.admin-monitoring__error-dot--critical {\n  background: #ef4444;\n}\n\n/* Table */\n.admin-monitoring__table-wrap {\n  overflow-x: auto;\n}\n\n.admin-monitoring__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.admin-monitoring__table th {\n  text-align: left;\n  padding: 10px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  background: var(--admin-surface);\n  border-bottom: 1px solid var(--admin-border);\n  white-space: nowrap;\n}\n\n.admin-monitoring__table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--admin-border-light);\n  vertical-align: middle;\n  color: var(--admin-text-primary);\n}\n\n.admin-monitoring__table tbody tr {\n  transition: background 0.15s;\n  cursor: pointer;\n}\n\n.admin-monitoring__table tbody tr:hover {\n  background: var(--admin-surface-hover);\n}\n\n.admin-monitoring__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.admin-error-time {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n  white-space: nowrap;\n}\n\n.admin-error-time__date {\n  font-size: 10px;\n  color: var(--admin-text-muted);\n}\n\n.admin-error-provider {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-error-provider__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.admin-error-model {\n  font-family: monospace;\n  font-size: 12px;\n  background: var(--admin-bg);\n  color: var(--admin-text-secondary);\n  padding: 2px 6px;\n  border-radius: var(--radius-sm);\n  white-space: nowrap;\n}\n\n.admin-error-type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border-radius: var(--radius-full);\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.admin-error-type-badge--critical {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n.admin-error-type-badge--warning {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-error-type-badge--timeout {\n  background: rgba(96, 165, 250, 0.12);\n  color: #60a5fa;\n}\n\n.admin-error-type-badge--rate {\n  background: rgba(167, 139, 250, 0.12);\n  color: #a78bfa;\n}\n\n.admin-error-dot {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  vertical-align: 0px;\n}\n\n.admin-error-dot--critical {\n  background: #ef4444;\n}\n\n.admin-error-dot--warning {\n  background: #f59e0b;\n}\n\n.admin-error-dot--timeout {\n  background: #3b82f6;\n}\n\n.admin-error-dot--rate {\n  background: #8b5cf6;\n}\n\n.admin-error-status-code {\n  font-family: monospace;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.admin-error-status-code--4xx {\n  color: var(--admin-warning);\n}\n\n.admin-error-status-code--5xx {\n  color: var(--admin-error);\n}\n\n.admin-error-status-code--timeout {\n  color: var(--admin-text-secondary);\n}\n\n.admin-error-msg {\n  max-width: 260px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n}\n\n.admin-error-resolved {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n}\n\n.admin-error-resolved--yes {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-error-resolved--no {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n/* Footer */\n.admin-monitoring__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  border-top: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n}\n\n.admin-monitoring__info {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n}\n\n.admin-monitoring__pagination {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.admin-monitoring__page-btn {\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--admin-border);\n  background: var(--admin-bg);\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-text-secondary);\n  transition: all 0.15s;\n}\n\n.admin-monitoring__page-btn:hover:not(:disabled) {\n  border-color: #a78bfa;\n  color: #a78bfa;\n}\n\n.admin-monitoring__page-btn--active {\n  background: var(--admin-border);\n  color: var(--admin-text-primary);\n  border-color: var(--admin-border);\n}\n\n.admin-monitoring__page-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n/* Modal */\n.admin-monitoring__modal-overlay {\n  display: flex;\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1000;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n}\n\n.admin-monitoring__modal {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n\n.admin-monitoring__modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-monitoring__modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-monitoring__modal-close {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md);\n  background: var(--admin-bg);\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-text-secondary);\n  transition: all 0.2s;\n}\n\n.admin-monitoring__modal-close:hover {\n  background: var(--admin-border);\n  color: var(--admin-text-primary);\n}\n\n.admin-monitoring__modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  max-height: calc(90vh - 140px);\n}\n\n.admin-monitoring__modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n}\n\n.admin-monitoring__modal-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-monitoring__modal-btn--primary {\n  background: linear-gradient(135deg, #a78bfa, #7c3aed);\n  color: white;\n}\n\n.admin-monitoring__modal-btn--primary:hover {\n  background: linear-gradient(135deg, #7c3aed, #6d28d9);\n  box-shadow: 0 4px 12px rgba(167, 139, 250, 0.3);\n}\n\n.admin-monitoring__modal-btn--secondary {\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  color: var(--admin-text-primary);\n}\n\n.admin-monitoring__modal-btn--secondary:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-text-dim);\n}\n\n.admin-monitoring__modal-btn-icon {\n  width: 14px;\n  height: 14px;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n}\n\n/* Detail Sections */\n.admin-detail-section-title {\n  font-size: 13px;\n  font-weight: 600;\n  margin: 20px 0 8px;\n  color: var(--admin-text-primary);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-detail-section-title:first-child {\n  margin-top: 0;\n}\n\n.admin-detail-section-title svg {\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  vertical-align: -2px;\n}\n\n.admin-detail-grid {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 0;\n}\n\n.admin-detail-grid dt {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  padding: 8px 0;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-detail-grid dd {\n  font-size: 13px;\n  color: var(--admin-text-primary);\n  padding: 8px 0;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-detail-grid dd:last-child,\n.admin-detail-grid dt:last-of-type {\n  border-bottom: none;\n}\n\n.admin-detail-code {\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  padding: 14px 16px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-family: monospace;\n  font-size: 12px;\n  line-height: 1.6;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-break: break-all;\n  margin-top: 8px;\n}\n\n.admin-detail-timeline {\n  position: relative;\n  padding-left: 20px;\n}\n\n.admin-detail-timeline::before {\n  content: '';\n  position: absolute;\n  left: 5px;\n  top: 4px;\n  bottom: 4px;\n  width: 2px;\n  background: var(--admin-border);\n}\n\n.admin-detail-timeline-item {\n  position: relative;\n  padding: 6px 0;\n  font-size: 12px;\n}\n\n.admin-detail-timeline-item::before {\n  content: '';\n  position: absolute;\n  left: -19px;\n  top: 10px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: 2px solid var(--admin-border);\n  background: var(--admin-surface);\n}\n\n.admin-detail-timeline-item--error::before {\n  border-color: var(--admin-error);\n  background: var(--admin-error-bg);\n}\n\n.admin-detail-timeline-item--success::before {\n  border-color: var(--admin-success);\n  background: var(--admin-success-bg);\n}\n\n.admin-detail-timeline-item__time {\n  color: var(--admin-text-muted);\n  font-size: 11px;\n}\n\n.admin-detail-timeline-item__text {\n  color: var(--admin-text-secondary);\n}\n\n/* ============================================================\n * P3-1 ~ P3-3, P2-4 신규 구조 (탭 / 메트릭 / 이벤트 / 로그 / 장애패턴)\n * ============================================================ */\n\n/* ---- Panel ---- */\n.admin-monitoring__panel {\n  padding: 0;\n}\n\n/* ---- Empty states ---- */\n.admin-monitoring__empty {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--admin-text-muted);\n  font-size: 13px;\n}\n\n.admin-monitoring__empty-sub {\n  margin-top: 8px;\n  font-size: 11px;\n  color: var(--admin-text-muted);\n}\n\n.admin-monitoring__empty-cell {\n  text-align: center;\n  padding: 60px 20px !important;\n  color: var(--admin-text-muted);\n}\n\n.admin-monitoring__empty-illus {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 72px;\n  height: 72px;\n  margin: 0 auto 12px;\n  border-radius: 50%;\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-muted);\n}\n\n.admin-monitoring__empty-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-secondary);\n  margin-bottom: 4px;\n}\n\n/* ---- Health Card (갱신 - 필드 실사 대응) ---- */\n.admin-health-card__info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.admin-health-card__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 11px;\n}\n\n.admin-health-card__row-label {\n  color: var(--admin-text-muted);\n  flex-shrink: 0;\n}\n\n.admin-health-card__row-value {\n  color: var(--admin-text-primary);\n  font-weight: 500;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ---- Stat Cards (메트릭 요약) ---- */\n.admin-monitoring__stat-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 12px;\n  padding: 20px;\n  background: var(--admin-bg);\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-monitoring__stat-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  padding: 14px 16px;\n  position: relative;\n  overflow: hidden;\n  transition: border-color 0.2s;\n}\n\n.admin-monitoring__stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 3px;\n}\n\n.admin-monitoring__stat-card--primary::before { background: var(--primary-500); }\n.admin-monitoring__stat-card--error::before   { background: var(--admin-error); }\n.admin-monitoring__stat-card--success::before { background: var(--admin-success); }\n.admin-monitoring__stat-card--info::before    { background: var(--admin-info); }\n.admin-monitoring__stat-card--muted::before   { background: var(--admin-text-muted); }\n\n.admin-monitoring__stat-card:hover {\n  border-color: var(--admin-text-dim);\n}\n\n.admin-monitoring__stat-label {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  font-weight: 500;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.admin-monitoring__stat-value {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--admin-text-primary);\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.admin-monitoring__stat-unit {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-muted);\n}\n\n/* ---- Chart ---- */\n.admin-monitoring__chart-wrap {\n  padding: 20px;\n  background: var(--admin-surface);\n}\n\n.admin-monitoring__chart {\n  width: 100%;\n  height: auto;\n  min-height: 280px;\n  display: block;\n}\n\n/* ---- Switch ---- */\n.admin-monitoring__switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 22px;\n  vertical-align: middle;\n}\n\n.admin-monitoring__switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.admin-monitoring__switch-slider {\n  position: absolute;\n  inset: 0;\n  background: var(--admin-border);\n  border-radius: 22px;\n  transition: background 0.2s;\n  cursor: pointer;\n}\n\n.admin-monitoring__switch-slider::before {\n  content: '';\n  position: absolute;\n  left: 3px;\n  top: 3px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 50%;\n  transition: transform 0.2s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.admin-monitoring__switch input:checked + .admin-monitoring__switch-slider {\n  background: var(--admin-success);\n}\n\n.admin-monitoring__switch input:checked + .admin-monitoring__switch-slider::before {\n  transform: translateX(18px);\n}\n\n.admin-monitoring__switch-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--admin-text-primary);\n  cursor: pointer;\n  padding: 8px 0;\n}\n\n/* ---- Icon Button ---- */\n.admin-monitoring__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-sm);\n  color: var(--admin-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.admin-monitoring__icon-btn:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--primary-500);\n  color: var(--primary-600);\n}\n\n.admin-monitoring__icon-btn svg {\n  width: 14px;\n  height: 14px;\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* ---- Form input/textarea (패턴 편집) ---- */\n.admin-monitoring__form-input,\n.admin-monitoring__form-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  transition: border-color 0.15s, box-shadow 0.15s;\n  box-sizing: border-box;\n}\n\n.admin-monitoring__form-textarea {\n  resize: vertical;\n  min-height: 80px;\n  line-height: 1.5;\n}\n\n.admin-monitoring__form-input:focus,\n.admin-monitoring__form-textarea:focus {\n  outline: none;\n  border-color: var(--primary-500);\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n/* ---- Collapse Button ---- */\n.admin-monitoring__collapse-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--admin-text-primary);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.admin-monitoring__collapse-btn svg {\n  width: 12px;\n  height: 12px;\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 2.5;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  transition: transform 0.2s;\n}\n\n.admin-monitoring__collapse-btn:hover {\n  color: var(--primary-600);\n}\n\n/* ---- Larger Modal for Patterns ---- */\n.admin-monitoring__modal {\n  max-width: 640px;\n}\n\n/* ---- Additional badge type (info/debug) ---- */\n.admin-error-type-badge--info {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-error-type-badge--debug {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-muted);\n}\n\n.admin-error-dot--info {\n  background: var(--admin-info);\n}\n\n.admin-error-dot--debug {\n  background: var(--admin-text-muted);\n}\n\n/* Spin animation (if not defined elsewhere) */\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Health card off state */\n.admin-health-card__badge--off {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-muted);\n}\n\n/* === Redesign: single-page dashboard === */\n\n.admin-monitoring__page {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.admin-monitoring__section {\n  background: var(--surface, #fff);\n  border: 1px solid var(--border-light, #e5e7eb);\n  border-radius: 12px;\n  padding: 16px 20px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.admin-monitoring__section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.admin-monitoring__section-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n}\n\n.admin-monitoring__section-subtitle {\n  font-size: 12px;\n  color: var(--text-tertiary, #9ca3af);\n  margin-top: 2px;\n}\n\n.admin-monitoring__empty-state {\n  padding: 28px 16px;\n  text-align: center;\n  color: var(--text-tertiary, #9ca3af);\n  font-size: 13px;\n}\n\n.admin-monitoring__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.admin-monitoring__period-select {\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--admin-border, #e5e7eb);\n  border-radius: var(--admin-radius-md, 8px);\n  background: var(--admin-surface, #fff);\n  font-size: 13px;\n  color: var(--admin-text-primary, #111827);\n  cursor: pointer;\n}\n\n.admin-monitoring__auto-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--admin-border, #e5e7eb);\n  border-radius: var(--admin-radius-md, 8px);\n  background: var(--admin-surface, #fff);\n  font-size: 12px;\n  color: var(--admin-text-secondary, #4b5563);\n  cursor: pointer;\n  user-select: none;\n}\n.admin-monitoring__auto-toggle--on {\n  background: var(--primary-50, #f5f3ff);\n  color: var(--primary-700, #6d28d9);\n  border-color: var(--primary-200, #ddd6fe);\n}\n.admin-monitoring__auto-toggle-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--admin-text-muted, #9ca3af);\n}\n.admin-monitoring__auto-toggle--on .admin-monitoring__auto-toggle-dot {\n  background: var(--admin-success, #10b981);\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);\n}\n\n.admin-monitoring__refresh-meta {\n  font-size: 11px;\n  color: var(--text-tertiary, #9ca3af);\n}\n.admin-monitoring__refresh-warn {\n  color: var(--admin-warning, #f59e0b);\n  font-size: 11px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.admin-monitoring__kpi-strip {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n}\n\n.admin-monitoring__kpi-card {\n  background: var(--surface, #fff);\n  border: 1px solid var(--border-light, #e5e7eb);\n  border-radius: 12px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-height: 82px;\n}\n.admin-monitoring__kpi-card--warn { border-color: var(--admin-warning, #f59e0b); }\n.admin-monitoring__kpi-card--error { border-color: var(--admin-error, #ef4444); }\n\n.admin-monitoring__kpi-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-tertiary, #9ca3af);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n.admin-monitoring__kpi-value {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--text-primary, #111827);\n  line-height: 1.1;\n}\n.admin-monitoring__kpi-sub {\n  font-size: 11px;\n  color: var(--text-secondary, #4b5563);\n}\n\n.admin-monitoring__health-alerts-row {\n  display: grid;\n  grid-template-columns: 3fr 2fr;\n  gap: 16px;\n}\n\n.admin-monitoring__metrics-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n.admin-monitoring__metric-cell {\n  background: var(--surface, #fff);\n  border: 1px solid var(--border-light, #e5e7eb);\n  border-radius: 10px;\n  padding: 12px 14px;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n}\n.admin-monitoring__metric-cell-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 8px;\n}\n.admin-monitoring__metric-cell-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n}\n.admin-monitoring__metric-cell-latest {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--primary-600, #7c3aed);\n}\n.admin-monitoring__metric-cell-chart {\n  flex: 1;\n  min-height: 140px;\n}\n\n.admin-monitoring__subtabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid var(--border-light, #e5e7eb);\n  margin-bottom: 12px;\n}\n.admin-monitoring__subtab {\n  background: transparent;\n  border: none;\n  padding: 10px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary, #4b5563);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n}\n.admin-monitoring__subtab:hover { color: var(--text-primary, #111827); }\n.admin-monitoring__subtab--active {\n  color: var(--primary-600, #7c3aed);\n  border-bottom-color: var(--primary-600, #7c3aed);\n}\n\n@media (max-width: 1200px) {\n  .admin-monitoring__kpi-strip { grid-template-columns: repeat(2, 1fr); }\n  .admin-monitoring__health-alerts-row { grid-template-columns: 1fr; }\n}\n\n.admin-monitoring__alerts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n.admin-monitoring__alert-row {\n  display: grid;\n  grid-template-columns: 10px 1fr auto;\n  gap: 8px;\n  align-items: start;\n  padding: 8px;\n  border: 1px solid var(--border-light, #e5e7eb);\n  border-radius: 8px;\n}\n.admin-monitoring__alert-dot { width: 8px; height: 8px; border-radius: 50%; margin-top: 6px; }\n.admin-monitoring__alert-title { font-size: 13px; color: var(--text-primary, #111827); }\n.admin-monitoring__alert-desc { font-size: 11px; color: var(--text-tertiary, #9ca3af); margin-top: 2px; }\n.admin-monitoring__alert-time { font-size: 11px; color: var(--text-tertiary, #9ca3af); white-space: nowrap; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
